import { makeStyles } from "@material-ui/core";

export default makeStyles(({ spacing, shadows, palette }) => ({
	controls: {
		position: "absolute",
		top: spacing(2),
		right: spacing(2),
	},
	controlButton: {
		backgroundColor: "white !important",
		boxShadow: shadows[3],
		"&:hover": {
			backgroundColor: "white",
		},
	},
	noAgreementsSign: {
		position: "absolute",
		top: "46%",
		width: "100%",
		textAlign: "center",
		fontSize: "32px",
		color: "#cddcdc",
		fontWeight: 600,
		textTransform: "uppercase",
	},
}));
